import { render, staticRenderFns } from "./ProgramSocFarmer.vue?vue&type=template&id=69e8857f"
import script from "./ProgramSocFarmer.vue?vue&type=script&lang=js"
export * from "./ProgramSocFarmer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports